
export function toTwoDigitNumber(num: number): string {
  if (num > 9) {
    return '' + num
  } else {
    return 0 + '' + num
  }
}
